import { Outlet } from 'react-router-dom';
import ClientsSidebar from './ClientsSidebar';

// Marco de la sección de clientes: menú a un lado y subrutas dentro.
//
// D4 — en móvil la barra lateral fija de 224px dejaba 151px para el contenido,
// así que por debajo de `md` se apila: menú arriba en horizontal y contenido
// debajo, a ancho completo. `h-screen` solo a partir de `md`, porque en móvil la
// página crece y se desplaza entera.
//
// Vivía dentro de App.tsx sin exportar. Está aquí para poder montarlo también
// fuera del árbol completo de rutas (el harness de D4 lo necesita), y así no hay
// dos copias del mismo marco que se desincronicen.
const ClientsLayout = () => (
    // La altura la marca el contenido, no la pantalla: con `md:h-screen` la
    // columna del menú terminaba a 100vh y al bajar quedaba cortada a media
    // página. Ahora crece con el contenido y el menú se queda fijo al desplazar.
    <div className="flex flex-col md:flex-row w-full pt-16">
        <ClientsSidebar />
        <div id="clients-content-container" className="flex-1 min-w-0 pb-16">
            <div className="p-4">
                <Outlet />
            </div>
        </div>
    </div>
);

export default ClientsLayout;
